import type { IPositionMeasurement } from '@lucimark/shared/models/geolocation'
import { PLAYER_ATTENTION_RECENT_OFFLINE_MS } from '@lucimark/shared/helpers/playerInAttention'

/** Default max age before a player-reported GPS fix is treated as stale (matches map lens). */
export const DEFAULT_PLAYER_POSITION_STALE_MS = PLAYER_ATTENTION_RECENT_OFFLINE_MS

export type TPlayerPositionFreshness = {
  stale: boolean
  ageMs: number | null
  timestampMs: number | null
}

export function resolvePlayerPositionFreshness(
  position: Pick<IPositionMeasurement, 'timestamp'> | null | undefined,
  nowMs = Date.now(),
  maxAgeMs = DEFAULT_PLAYER_POSITION_STALE_MS
): TPlayerPositionFreshness {
  const timestampMs = position?.timestamp
  if (timestampMs == null || typeof timestampMs !== 'number' || !Number.isFinite(timestampMs)) {
    return { stale: false, ageMs: null, timestampMs: null }
  }
  const ageMs = Math.max(0, nowMs - timestampMs)
  return {
    stale: ageMs > maxAgeMs,
    ageMs,
    timestampMs
  }
}

export function isPlayerPositionMeasurementStale(
  position: Pick<IPositionMeasurement, 'timestamp'> | null | undefined,
  nowMs = Date.now(),
  maxAgeMs = DEFAULT_PLAYER_POSITION_STALE_MS
): boolean {
  return resolvePlayerPositionFreshness(position, nowMs, maxAgeMs).stale
}
